import axios from 'axios';
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_BASE_URL } from '../consts';

export const getFleetAverage = createAsyncThunk(
  'data/fleetAverage',
  async (arg, { getState, rejectWithValue }) => {
    try {
      const { user } = <any> getState();
      const config = {
        headers: {
          Authorization: `Bearer ${user.userToken}`,
        },
      };

      const { data } = await axios.get(API_BASE_URL + 
        `/v1/data/fleetAverage`, config);
      return data;
    } catch (error: any) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);